import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import HeadComponent from "../components/HeadComponent/HeadComponent";
import CustomSkeleton from "../components/CustomSkeleton/CustomSkeleton";
import dynamic from "next/dynamic";
import LandingLayout from "../components/_Landings/layout";
import { useEffect } from "react";
var DynamicLanding = dynamic(function() {
    return import("../components/_Landings/CCPP/CCPPLanding");
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                require.resolveWeak("../components/_Landings/CCPP/CCPPLanding")
            ];
        }
    },
    ssr: false,
    loading: function() {
        return /*#__PURE__*/ _jsx(CustomSkeleton, {});
    }
});
var CCPPPage = function() {
    useEffect(function() {
        window.scrollTo(0, 0);
    }, []);
    var headerProps = {
        title: "Ahorro en Luz y Gas para Comunidades de Propietarios y Administradores de Fincas",
        keywords: "Comparador de tarifas de luz y gas para comunidades, \n      Tarifas de gas y electricidad para administradores de fincas, \n      Soluciones en energ\xeda para propiedades, Ahorro en costos de gas y luz para comunidades, \n      Tarifas eficientes para gesti\xf3n de fincas, Eficiencia energ\xe9tica para comunidades, \n      Tarifas de gas competitivas para administradores, Asesor\xeda en tarifas de gas y electricidad, \n      Optimizaci\xf3n de tarifas para propietarios, Consultor\xeda en ahorro de energ\xeda para fincas",
        content: "Explora y compara tarifas de luz y gas adaptadas a las necesidades de tus comunidades. \n    Con Fiva, accede a opciones que te ayudan a reducir costos y aumentar la eficiencia energ\xe9tica en la gesti\xf3n de tus propiedades. \n    Proceso sencillo y adaptado para un ahorro efectivo."
    };
    return /*#__PURE__*/ _jsxs(LandingLayout, {
        children: [
            /*#__PURE__*/ _jsx(HeadComponent, _object_spread({}, headerProps)),
            /*#__PURE__*/ _jsx(DynamicLanding, {})
        ]
    });
};
export default CCPPPage;
